/*!
 * Copyright (c) Andrey Dias (http://github.com/andreymdias)
 * Licensed Under MIT (http://opensource.org/licenses/MIT)
 * 
 * Vue Router Middeware @ Version 0.2.0
 * 
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["VueRouterMiddleware"] = factory();
	else
		root["VueRouterMiddleware"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
* middlewares sleeps here, wait for route change
*/

var store = [];

/**
* add function to store of middlewares
*/

var push = function push(_ref) {
  var name = _ref.name,
      callback = _ref.callback;

  store = [].concat(_toConsumableArray(store), [{ name: name, callback: callback }]);
};

/**
* remove middleware by name
*/

var remove = function remove(middlewareName) {
  store = store.filter(function (_ref2) {
    var name = _ref2.name;

    return name !== middlewareName;
  });
};

/**
* find middleware by name
*/

var search = function search(middlewareName) {
  return [].concat(_toConsumableArray(store)).find(function (_ref3) {
    var name = _ref3.name;

    return name === middlewareName;
  });
};

/**
* return middleware store
*/

var all = function all() {
  return [].concat(_toConsumableArray(store));
};

exports.push = push;
exports.remove = remove;
exports.search = search;
exports.all = all;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
* Normalize diferent ways to find middleware in route.meta
*/

var normalizeArgs = function normalizeArgs(val, name) {
  if (val.hasOwnProperty(name)) return { name: name, args: val[name] };else if (val == name) return { name: name, args: null };else return false;
};

/**
* Get name and arguments from route.meta middlewares
*/

var getInfo = function getInfo(_ref) {
  var name = _ref.name,
      route = _ref.route;
  var middlewares = route.meta.middlewares;


  return (middlewares || []).map(function (val) {
    return normalizeArgs(val, name);
  }).find(function (val) {
    return val.name === name;
  });
};

/**
* Check if is match attribute in route
*/

var isMatched = function isMatched(route) {
  return route.matched;
};

/**
* Check if has middleware active in route
*/

var matchMiddleware = function matchMiddleware(name, route) {
  if (isMatched(route)) {
    return route.matched.some(function (record) {
      return getInfo({ name: name, route: record });
    });
  }

  return !!getInfo({ name: name, route: route });
};

/**
* get all middlewares marched info
*/

var getMiddlewareInfo = function getMiddlewareInfo(name, route) {
  if (isMatched(route)) {
    return route.matched.map(function (record) {
      return getInfo({ name: name, route: record });
    }).filter(function (middleware) {
      return middleware !== undefined;
    }).find(function (middleware) {
      return middleware.name === name;
    });
  }

  return getInfo({ name: name, route: route });
};

exports.default = getInfo;
exports.isMatched = isMatched;
exports.matchMiddleware = matchMiddleware;
exports.getMiddlewareInfo = getMiddlewareInfo;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var events = {
  onCancelMiddleware: []

  /**
  * get listeners by name
  */

};var getListeners = function getListeners(name) {
  return events[name];
};

/**
* add a store events
*/

var addListener = function addListener(name, callback) {
  getListeners(name).push({ callback: callback });
};

/**
* add multiples listeners
*/

var addMultipleListeners = function addMultipleListeners(listeners) {
  for (var eventName in listeners) {
    if (listeners.hasOwnProperty(eventName)) addListener(eventName, listeners[eventName]);
  }
};

/**
* remove listener from store of events
*/

var removeListener = function removeListener(name, callback) {
  events = getListeners(name).filter(function (evStore) {
    return evStore.callback.toString() !== callback.toString();
  });
};

/**
* dispatch function callback
*/

var emitEvent = function emitEvent(name) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  getListeners(name).forEach(function (ev) {
    return ev.callback.apply(null, args);
  });
};

exports.addListener = addListener;
exports.removeListener = removeListener;
exports.emitEvent = emitEvent;
exports.addMultipleListeners = addMultipleListeners;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _store = __webpack_require__(0);

/**
* stores callback and name to dispatch on route change
*/

var create = function create(name, callback) {

  (0, _store.push)({ name: name, callback: callback });
};

exports.default = create;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _install = __webpack_require__(5);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_install).default;
  }
});

var _middleware = __webpack_require__(10);

Object.defineProperty(exports, 'middleware', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_middleware).default;
  }
});

var _create = __webpack_require__(3);

Object.defineProperty(exports, 'createMiddleware', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_create).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _init = __webpack_require__(6);

var _init2 = _interopRequireDefault(_init);

var _events = __webpack_require__(2);

var _create = __webpack_require__(3);

var _create2 = _interopRequireDefault(_create);

var _camelToDash = __webpack_require__(8);

var _camelToDash2 = _interopRequireDefault(_camelToDash);

var _log = __webpack_require__(9);

var _log2 = _interopRequireDefault(_log);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var install = function install(Vue, _ref) {
  var router = _ref.router,
      middlewares = _ref.middlewares,
      events = _ref.events;

  if (router === undefined) (0, _log2.default)('Unvalid router instance');

  /**
  * create middleware passed by arguments
  */

  if (middlewares !== undefined) for (var keyName in middlewares) {
    (0, _create2.default)((0, _camelToDash2.default)(keyName), middlewares[keyName]);
  }

  /**
  * Set Events
  */

  (0, _events.addMultipleListeners)(events);

  /**
  * integrate logic with vue-router
  */

  router.beforeEach(_init2.default);
};

exports.default = install;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _store = __webpack_require__(0);

var _getInfo = __webpack_require__(1);

var _run = __webpack_require__(7);

var _run2 = _interopRequireDefault(_run);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* Get all middlewares in store
* check contains in route
* and run middleware logic
*/

var init = function init(to, from, next) {

  var middlewares = (0, _store.all)().filter(function (_ref) {
    var name = _ref.name;

    return (0, _getInfo.matchMiddleware)(name, to);
  });

  if (middlewares.length) (0, _run2.default)({ to: to, from: from, next: next })(middlewares);else next();
};

exports.default = init;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _events = __webpack_require__(2);

var _getInfo = __webpack_require__(1);

/**
* Run middleware logic.
*
* run middleware callbacks in sequence
* when in callback call method next(), init next middleware
* if params in next() method is equal false,
* block other middlewares and dispatch cancel event
* if last middleware dispatch next() native from vue-router
*/

var run = function run(_ref) {
  var to = _ref.to,
      from = _ref.from,
      next = _ref.next;

  var middlewares = [];

  var nextMiddleware = function nextMiddleware(nextIndex) {
    resolve(nextIndex, middlewares[nextIndex]);
  };

  var resolve = function resolve(index, _ref2) {
    var name = _ref2.name,
        callback = _ref2.callback;

    var nextTick = function nextTick(routeParams) {

      if (routeParams == false) {
        (0, _events.emitEvent)('onCancelMiddleware', [name, to, from, next]);
      }

      var rulesToCallNext = [(typeof routeParams === 'undefined' ? 'undefined' : _typeof(routeParams)) === 'object', typeof routeParams === 'string', routeParams === false, index == middlewares.length - 1];

      if (rulesToCallNext.some(function (value) {
        return value;
      })) {
        next(routeParams);
      } else {
        nextMiddleware(index + 1);
      }
    };

    var _getMiddlewareInfo = (0, _getInfo.getMiddlewareInfo)(name, to),
        args = _getMiddlewareInfo.args;

    callback(args, to, from, nextTick);
  };

  return function (store) {
    middlewares = store;
    nextMiddleware(0);
  };
};

exports.default = run;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (str) {
  return str.replace(/\W+/g, '-').replace(/([a-z\d])([A-Z])/g, '$1-$2').toLowerCase();
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (msg) {
	console.warn("[Vue Router Middleware] " + new Date().toISOString() + ": " + msg);
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (options, arr) {

	var pushMeta = function pushMeta(option) {
		return arr.map(function (route) {
			if (!route.meta) {
				route.meta = {
					middlewares: []
				};
			}

			if (!route.meta.middlewares) {
				route.meta.middlewares = [];
			}

			if (route.meta.middlewares.indexOf(option) == -1) route.meta.middlewares.push(option);

			return route;
		});
	};

	if (!options) {
		return arr;
	}
	if (Array.isArray(options)) {
		var routes = arr;

		for (var i = 0, len = options.length; i < len; i++) {
			routes = pushMeta(options[i]);
		}

		return routes;
	} else {
		return pushMeta(options);
	}
};

/***/ })
/******/ ]);
});